import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm, reset } from "redux-form";
import { api } from "api";
import { NotificationManager, __esModule} from "react-notifications";
import _ from 'lodash';
import moment from 'moment';

let url = 'reportes' ;
let form = '';
let dirGrid = '/';

export const constants ={
    LOADER: 'REPORTE_MATERIA_PRIMA_LOADER',
    DATA: "REPORTE_MATERIA_PRIMA_DATA",
    ITEM: "REPORTE_MATERIA_PRIMA_ITEM",
    PAGE: `REPORTE_MATERIA_PRIMA_PAGE`,
    PAGE_LOTE: 'REPORTE_MATERIA_PRIMA_PAGE_LOTE',
    SET_PRODUCTO: 'SET_PRODUCTO_REPORTE_MATERIA_PRIMA',
    SET_PRODUCTO_LOTE: 'SET_PRODUCTO_LOTE_REPORTE_MATERIA_PRIMA',
    BODEGA_TRANSICION_FILTER: 'SET_BODEGA_TRANSICION_FILTER',
    VENDIBLE_FILTER: 'SET_VENDIBLE_FILTER',
    FACTURADO_FILTER: 'SET_FACTURADO_FILTER',
    SET_BODEGA: 'SET_BODEGA_MATERIA_PRIMA',
    SET_FECHA_CIERRE_COSTO:'SET_FECHA_CIERRE_COSTO',
    SEARCH: `PRODUCTO_MATERIA_PRIMA_SEARCH`,
}

// PURE ACTIONS

const setLoader = loader =>({
    type:constants.LOADER,
    loader
})

const setData = (type, data) => ({
    type:type,
    data
})

const setPage = (type, page) => (dispatch, getStore)  => {
    dispatch({
        type: type,
        page,
    })
};

const setBodega = bodega => (dispatch) => {
    dispatch({
        type: constants.SET_BODEGA,
        bodega
    })
}

const setProducto = producto => ({
    type: constants.SET_PRODUCTO,
    producto
})

const setProductoLote = productoLote => ({
    type: constants.SET_PRODUCTO_LOTE,
    productoLote
})

const setSearch = search => ({
    type: constants.SEARCH,
    search,
});

// ACTIONS

const listar = (page = 1) => (dispatch, getStore) => {
    const resource = getStore().reporteMateriaPrima;
    const params = { page };
    if(resource.producto){
        params.producto = resource.producto.id
    }
    if(resource.bodega){
        params.bodega = resource.bodega.id
    }
    if(resource.fecha_cierre){
        params.fecha_cierre = (resource.fecha_cierre.format('YYYY-MM-DD'));
    }
    params.search = resource.search
    params.bodega_transicion = resource.bodega_transicion_filter;
    params.vendible = resource.vendible_filter;
    params.facturado = resource.facturado_filter;
    dispatch(setLoader(true));
    api.get(`${url}/materia_prima`, params).then((response) => {
        dispatch(setData(constants.DATA ,response));
        dispatch(setPage(constants.PAGE, page));
    }).catch((error) => {
        mensajeError(error)
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const listarLote = (page = 1) => (dispatch, getStore) => {
    const resource = getStore().reporteMateriaPrima;
    const params = {
        page,
        producto: resource.productoLote
    };
    if(resource.bodega){
        params.bodega = resource.bodega.id
    }
    dispatch(setLoader(true));
    api.get(`${url}/lote_materia_prima`, params).then((response) => {
        dispatch(setData(constants.ITEM ,response));
        dispatch(setPage(constants.PAGE_LOTE, page));
    }).catch((error) => {
        mensajeError(error)
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const mensajeError = (error) => {
    let mensaje = 'Hubo un error';
        if(error){
            if(error.detail){
                mensaje = error.detail
            }else {
                mensaje = Object.keys(error)[0] + " " + error[Object.keys(error)[0]][0]
            }
        }
        NotificationManager.error(mensaje, 'ERROR');
}

const changeBodega = (value) => (dispatch) => {
    dispatch(setBodega(value));
    dispatch(listar())
}

const changeProducto = (value) => (dispatch) => {
    dispatch(setProducto(value));
    dispatch(listar())
}

const changeProductoLote = (value) => (dispatch) => {
    dispatch(setProductoLote(value));
    dispatch(listarLote())
}

const searchChange = search => (dispatch) => {
    dispatch(setSearch(search));
    dispatch(listar());
};

const HistorialCostos = () => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const resource = getStore().reporteMateriaPrima;
    let fecha_cierre = resource.fecha_cierre;
    api.post(`productos/Historial_costos`, {fecha_cierre}).then((response) => {
        NotificationManager.success('Historico de costos guardado', 'Éxito', 3000);
        dispatch(listar());
    }).catch((error) => {
        let mensaje = 'Error en la creacion del Historico';
        console.log(error)
        if(error){
            if(error.detail){
                mensaje = error.detail
            }else {
                try {
                    mensaje = Object.keys(error)[0] + " " + error[Object.keys(error)[0]][0]
                } catch (error) {
                    mensaje = "Error en la creacion del historico";
                }
            }
        }
        NotificationManager.error(mensaje, 'ERROR');
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const changeFecha = (value) => dispatch => {
    dispatch(setData(constants.SET_FECHA_CIERRE_COSTO, value));
    dispatch(listar())
}

const setBodegaTransicionFilter = (bodega_transicion_filter, bodega) => (dispatch, getStore) => {
    dispatch({
        type: constants.BODEGA_TRANSICION_FILTER,
        bodega_transicion_filter: bodega_transicion_filter
    });
    dispatch(listar(1, bodega));
}

const setVendibleFilter = (vendible_filter, bodega) => (dispatch, getStore) => {
    dispatch({
        type: constants.VENDIBLE_FILTER,
        vendible_filter: vendible_filter
    });
    dispatch(listar(1, bodega));
}

const setFacturadoFilter = (facturado_filter, bodega) => (dispatch, getStore) => {
    dispatch({
        type: constants.FACTURADO_FILTER,
        facturado_filter: facturado_filter
    });
    dispatch(listar(1, bodega));
}

export const actions = {
    listar,
    listarLote,
    changeBodega,
    changeProducto,
    changeProductoLote,
    setBodegaTransicionFilter,
    setVendibleFilter,
    setFacturadoFilter,
    HistorialCostos,
    changeFecha,
    searchChange
}

export const reducers = {
    [constants.LOADER]:(state,{loader}) =>{
        return{
            ...state,
            loader,
        };
    },
    [constants.DATA]:(state,{data}) =>{
        return{
            ...state,
            data,
        };
    },
    [constants.ITEM]:(state,{data}) =>{
        return{
            ...state,
            item: data,
        };
    },
    [constants.PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [constants.PAGE_LOTE]: (state, { page }) => {
        return {
            ...state,
            pageLote: page,
        };
    },
    [constants.ORDERING]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [constants.SET_PRODUCTO]: (state, { producto }) => {
        return {
            ...state,
            producto
        };
    },
    [constants.SET_PRODUCTO_LOTE]: (state, { productoLote }) => {
        return {
            ...state,
            productoLote
        };
    },
    [constants.BODEGA_TRANSICION_FILTER]: (state, { bodega_transicion_filter }) => {
        return {
            ...state,
            bodega_transicion_filter,
        };
    },
    [constants.VENDIBLE_FILTER]: (state, { vendible_filter }) => {
        return {
            ...state,
            vendible_filter,
        };
    },
    [constants.FACTURADO_FILTER]: (state, { facturado_filter }) => {
        return {
            ...state,
            facturado_filter,
        };
    },
    [constants.SET_BODEGA]: (state, { bodega }) => {
        return {
            ...state,
            bodega
        };
    },
    [constants.SET_FECHA_CIERRE_COSTO]: (state, { data }) => {
        return {
            ...state,
            fecha_cierre: data
        };
    },
    [constants.SEARCH]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
}

export const initialState = {
    loader:false,
    data: {
        results: [],
        count: 0,
    },
    item: {},
    page: 1,
    pageLote: 1,
    ordering: '',
    producto: undefined,
    productoLote: undefined,
    bodega: undefined,
    fecha_cierre: moment(),
    bodega_transicion_filter: 0,
    vendible_filter: 0,
    facturado_filter: 0,
    search: ''
}

export default handleActions(reducers, initialState);
